import { OrgIdContext } from "../../../store/orgId_context";
import { tx } from "../../../lib/ddd/ddd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import classes from "./IntegrationComponentsFull.module.scss"

const CSharpHowTo = () =>{
    const {  integrationDevice } = useContext(OrgIdContext);
    return(
        <>
        To send requests to our service, you can use whatever technology can send HTTPS POST/GET requests.
        In this C# example we will be using  <NavLink to="https://learn.microsoft.com/en-us/dotnet/api/system.net.http.httpclient?view=net-8.0">System.Net.Http.HttpClient</NavLink> class. The request needs three pieces of information:
        <ol style={{paddingLeft:"1rem", paddingTop:"1rem"}}>
            <li>Identification (&lt;connectionKey&gt;)</li>
            <li>API endpoint (&lt;api-name&gt;)</li> 
            <li>Data (&lt;parameters&gt;)</li>
        </ol>
        Here is an example such of a request:
                
        <div className={classes["code-snippet"]}>
            var client = new HttpClient();<br/>
            client.DefaultRequestHeaders.Add("Authorization", "IoT <span className={classes.red}>&lt;connectionKey&gt;</span>:EUeInvoices");<br/>
            {/* client.DefaultRequestHeaders.Accept.Add(new MediaTypeWithQualityHeaderValue("application/json"));<br/> */}
            var response = await client.PostAsync("https://{window.location.hostname}/api/service/EUeInvoices.<span className={classes.red}>&lt;api-name&gt;</span>", <span className={classes.red}>&lt;parameters&gt;</span>);
        </div>
        You will use the below <u>Integration Key</u> to learn and test the integration with our service. It is also used for all requests triggered by the 
        learning playground. All invoices sent with this key can be viewed in the "Integration -&gt; {tx("DDDI_Save")} -&gt; <NavLink to="/sent-integration-invoices">Sent invoices</NavLink>" menu (if the sending was 
        successful, at least to the extent that the object was accepted for processing).
        <div className={classes["code-snippet"]} >{integrationDevice}</div>
        <div className="alert alert-warning">
        Note! This is not a key intended to be used for your company's actual invoices. You can find the key that belongs to your company 
        in your company profile. Start using your company's key (called Connection Key) only when you've already finished testing integration.
        </div>
        And finally, for this we will be using the "{tx("EUeInvoices.DDDI_Save")}" API endpoint, making our request the following:
        <div className={classes["code-snippet"]}>
            var client = new HttpClient();<br/>
            client.DefaultRequestHeaders.Add("Authorization", "IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices");<br/>
            {/* client.DefaultRequestHeaders.Accept.Add(new MediaTypeWithQualityHeaderValue("application/json"));<br/> */}
            var response = await client.PostAsync("https://{window.location.hostname}/api/service/EUeInvoices.<span className={classes.green}>{tx("DDDI_Save")}</span>", <span className={classes.red}>&lt;parameters&gt;</span>);
        </div>
        </>
    )
}

export default CSharpHowTo;